module.exports = __webpack_public_path__ + "img/icon-nodata.1a629d3.png";